// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Stats_statsSection__9oXh6 {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;
}

.Stats_userInfoSection__ERxhb {
  display: flex;
  gap: 16px;
  padding: 24px;
  border-radius: 12px;
  min-width: 320px;
}

.Stats_userAvatar__uDh7l {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: linear-gradient(45deg, #00ff87, #60efff);
}

.Stats_userDetails__ftCb\\+ {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.Stats_userHeader__KbRpi {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.Stats_nameAndLevel__\\+VlFl {
  display: flex;
  align-items: center;
  gap: 12px;
}

.Stats_userName__snuwX {
  font-size: 24px;
  font-weight: 600;
}

.Stats_levelBadge__-303n {
  background: #202020;
  padding: 2px 8px;
  border-radius: 4px;
  font-size: 12px;
}

.Stats_tokenRow__MoGnG {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.Stats_tokenInfo__rMAco {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #888;
  font-size: 14px;
}

.Stats_tokenIcon__x4KH9 {
  font-size: 16px;
}

.Stats_mintButton__KGRQF {
  padding: 6px 16px;
  background: #ffffff;
  color: #000000;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.Stats_mintButton__KGRQF:hover {
  opacity: 0.9;
}

.Stats_statsGrid__4P6Ka {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
}

.Stats_statCard__138TA {
  display: flex;
  flex-direction: column;
  gap: 12px;
  border-radius: 12px;
  text-align: left;
  padding-right: 12px;
}

.Stats_statCard__138TA {
  color: #fff;
  font-size: 12px;
}

.Stats_statValue__8BJmI {
  font-size: 16px;
  font-weight: 600;
}

@media (max-width: 1024px) {
  .Stats_statsSection__9oXh6 {
    flex-direction: column;
  }

  .Stats_userInfoSection__ERxhb {
    width: 100%;
    min-width: unset;
  }

  .Stats_statsGrid__4P6Ka {
    width: 100%;
  }
}

@media (max-width: 768px) {
  .Stats_statsSection__9oXh6 {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/dappPages/DashboardPage/Stats/Stats.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oDAAoD;AACtD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF","sourcesContent":[".statsSection {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 40px;\n}\n\n.userInfoSection {\n  display: flex;\n  gap: 16px;\n  padding: 24px;\n  border-radius: 12px;\n  min-width: 320px;\n}\n\n.userAvatar {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: linear-gradient(45deg, #00ff87, #60efff);\n}\n\n.userDetails {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.userHeader {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.nameAndLevel {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.userName {\n  font-size: 24px;\n  font-weight: 600;\n}\n\n.levelBadge {\n  background: #202020;\n  padding: 2px 8px;\n  border-radius: 4px;\n  font-size: 12px;\n}\n\n.tokenRow {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.tokenInfo {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  color: #888;\n  font-size: 14px;\n}\n\n.tokenIcon {\n  font-size: 16px;\n}\n\n.mintButton {\n  padding: 6px 16px;\n  background: #ffffff;\n  color: #000000;\n  border: none;\n  border-radius: 4px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.mintButton:hover {\n  opacity: 0.9;\n}\n\n.statsGrid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 12px;\n}\n\n.statCard {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  border-radius: 12px;\n  text-align: left;\n  padding-right: 12px;\n}\n\n.statCard {\n  color: #fff;\n  font-size: 12px;\n}\n\n.statValue {\n  font-size: 16px;\n  font-weight: 600;\n}\n\n@media (max-width: 1024px) {\n  .statsSection {\n    flex-direction: column;\n  }\n\n  .userInfoSection {\n    width: 100%;\n    min-width: unset;\n  }\n\n  .statsGrid {\n    width: 100%;\n  }\n}\n\n@media (max-width: 768px) {\n  .statsSection {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"statsSection": `Stats_statsSection__9oXh6`,
	"userInfoSection": `Stats_userInfoSection__ERxhb`,
	"userAvatar": `Stats_userAvatar__uDh7l`,
	"userDetails": `Stats_userDetails__ftCb+`,
	"userHeader": `Stats_userHeader__KbRpi`,
	"nameAndLevel": `Stats_nameAndLevel__+VlFl`,
	"userName": `Stats_userName__snuwX`,
	"levelBadge": `Stats_levelBadge__-303n`,
	"tokenRow": `Stats_tokenRow__MoGnG`,
	"tokenInfo": `Stats_tokenInfo__rMAco`,
	"tokenIcon": `Stats_tokenIcon__x4KH9`,
	"mintButton": `Stats_mintButton__KGRQF`,
	"statsGrid": `Stats_statsGrid__4P6Ka`,
	"statCard": `Stats_statCard__138TA`,
	"statValue": `Stats_statValue__8BJmI`
};
export default ___CSS_LOADER_EXPORT___;
